import React from 'react'
import { Box } from '../../../third-party-components/material-ui';
import { 
    AssessmentContainer, 
    AssessmentBody, 
    AssessmentContent, 
    AssessmentNavigationPrevious, 
    AssessmentNavigationNext, 
    AssessmentFooter 
} from '../common';
import NextButton from '../../../assets/images/next@2x.png';

const TaskInstruction = ({toPrevious, toNext, image, text}) => (
    <AssessmentContainer> 
        <AssessmentBody>
            <AssessmentNavigationPrevious to={toPrevious} />
            <AssessmentContent>
                <Box className="task-instruction-container">
                    <Box className="task-instruction-text">
                        {text}
                    </Box>
                    <Box className="task-instruction-next">
                        Click <img src={NextButton} alt="Next" style={{ height:'auto', width:'0.5em'}} /> to try a practice question.
                    </Box>
                    <Box className="task-instruction-preview">
                        <Box>
                            <img className="task-instruction-image" src={image} alt="" />
                        </Box>
                    </Box>
                </Box>
            </AssessmentContent>
            <AssessmentNavigationNext to={toNext} />
        </AssessmentBody>
        <AssessmentFooter></AssessmentFooter>
    </AssessmentContainer>
)

export default TaskInstruction;